@if (companyFlagItems$ | async; as companyFlagItems) {
  <div #browserFilterCompanyFlagSelectDiv>
    <div class="form-group">
      <ng-content></ng-content>
      <div
        [popover]="popTemplate"
        [containerClass]="'popover-wide'"
        container="body"
        [placement]="'right'"
        triggers=""
        [isOpen]="popOverOpen">
        <div class="input-group mb-2">
          <input
            type="text"
            id="browser-filter-company-flag-{{ operator() }}"
            class="form-control bg-white"
            [placeholder]="'browser_view.company_flags_filter.search_placeholder' | translate"
            aria-label="Search for company flags"
            (click)="onClickSearch()"
            [disabled]="!selectedFilterType()"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearch($event)" />
          <div class="input-group-append">
            @if (searchQuery.length) {
              <button class="btn btn-info" type="button" (click)="clearSearchQuery()">
                <i class="fa fa-times"></i>
              </button>
            } @else {
              <button class="btn btn-info" type="button" [class.disabled]="true">
                <i class="fa fa-search"></i>
              </button>
            }
          </div>
        </div>
      </div>
      <div>
        <ng-template #popTemplate>
          <div
            class="overflow-x-hidden overflow-y-auto max-vh-70"
            #popContainer
            nkClickOutside
            (clickOutside)="closePopover()">
            <button nkButton color="link" andClass="float-end" (click)="closePopover()">
              <i class="fa fa-times fa-2x"></i>
            </button>
            <h5 class="py-2" [innerHtml]="title()"></h5>
            <div class="row w-100 d-flex flex-wrap">
              @if (companyFlagItems.length === 0) {
                <div class="text-muted">
                  {{ 'company_browser.flag_filter.no_flags_found_for_search_query' | translate: { searchQuery } }}
                </div>
              }
              @for (companyFlagItem of companyFlagItems; track companyFlagItem.companyFlagType.uuid) {
                <div class="col-sm-12 col-md-6 col-xl-4 mt-1 mb-1" style="min-width: 200px">
                  @if (!companyFlagItem.featureAccessGranted) {
                    <div class="text-right">
                      <span class="badge badge-success text-uppercase">
                        {{ companyFlagItem.requiredFeature?.app_feature_key }}
                      </span>
                    </div>
                  }
                  <button
                    nkButton
                    andClass="btn-text text-left {{
                      !companyFlagItem.featureAccessGranted ||
                      siblingSelectedCompanyFlagTypeUuidDict()[companyFlagItem.companyFlagType.uuid]
                        ? 'disabled'
                        : ''
                    }} "
                    style="width: 100%; height: 100%"
                    [disabled]="
                      !companyFlagItem.featureAccessGranted ||
                      !!siblingSelectedCompanyFlagTypeUuidDict()[companyFlagItem.companyFlagType.uuid]
                    "
                    [color]="selectedCompanyFlagTypeUuidDict()[companyFlagItem.companyFlagType.uuid] ? 'info' : 'light'"
                    (click)="toggleCompanyFlagType(companyFlagItem.companyFlagType)">
                    <div class="row">
                      <div class="col-2">
                        <nk-company-flag-icon
                          andClass="float-start mt-2 me-2"
                          size="md"
                          andClass="mt-2 mb-2"
                          [companyFlagCategoryKey]="companyFlagItem.companyFlagType.company_flag_category_key"
                          [companyFlagTypeAppIconUuid]="companyFlagItem.companyFlagType.app_icon_uuid">
                        </nk-company-flag-icon>
                      </div>
                      <div class="col-10">
                        {{
                          translationPrefix + '.' + companyFlagItem.companyFlagType.company_flag_type_key | translate
                        }}
                      </div>
                    </div>
                  </button>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
}
